export default {
  LOAD_RECIPES: 'LOAD_RECIPES',
};
